import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import UiContent from '../../../../Components/Common/UiContent';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';
import Search404 from '../../../AuthenticationInner/Errors/Search';
import { FormDictionaryProvider } from '../../../Warehouse/Guide/Forms/FormDictionaryContext';
import IntakeFormDictionaryBootstrap from './IntakeFormDictionaryBootstrap';
import IntakeList from './IntakeList';

const RespelIntake = () => {
	const { establishmentId } = useParams();
	useRedirectEstablishmentActiveContent(
		'/residue/respel/movements/establishmentId',
	);

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'RESPEL', icon: 'icon-circle-alert' },
	];

	if (establishmentId === 'all') {
		return (
			<>
				<UiContent />
				<div className='page-content mb-10' style={{ paddingBottom: '90px' }}>
					<Container fluid>
						<BreadCrumb
							title='Movimientos RESPEL'
							hidden
							icon='icon-circle-alert'
						/>
						<Search404 />
					</Container>
				</div>
			</>
		);
	}

	return (
		<>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Movimientos RESPEL'
						links={breadcrumbLinks}
						icon='icon-circle-alert'
					/>
					<FormDictionaryProvider>
						<IntakeFormDictionaryBootstrap />
						<IntakeList establishmentId={establishmentId} />
					</FormDictionaryProvider>
				</Container>
			</div>
		</>
	);
};

export default RespelIntake;
